// ─── Constants (exported for client-side / test reuse) ───

export const MAX_COVER_FILE_SIZE = 25 * 1024 * 1024; // 25 MB
export const COVER_SIZE_LIMIT_LABEL = `${MAX_COVER_FILE_SIZE / (1024 * 1024)} MB`;
export const ALLOWED_COVER_MIME_TYPES = new Set([
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/gif",
]);
